const ClaimInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  class: ""
};
export { ClaimInitialValues };
